import { useAsertoApiWithAuth, v1Api } from '@aserto/console-common'

import { useConfig } from '../services/ConfigProvider'

export function useConsoleBackendClient() {
  const { backendServiceUrl } = useConfig()
  return useAsertoApiWithAuth(v1Api(backendServiceUrl))
}
